import { Col, Form, Input, Row, Switch } from 'antd'

import { requiredRules } from 'src/app-constants'
import { useLocales } from 'src/locales'

const { Item } = Form

export const ProfileToggleStatus = () => {
  const { t } = useLocales()

  return (
    <Row gutter={[24, 24]}>
      <Col xs={24} lg={12}>
        <Item
          name="isPhysical"
          label={t('organizational_structure.structure_logic')}
          valuePropName="checked"
        >
          <Switch />
        </Item>
      </Col>

      <Col xs={24} md={12} lg={8} xl={6}>
        <Item
          name="name"
          label={t('organizational_structure.name')}
          rules={requiredRules}
        >
          <Input placeholder={t('organizational_structure.name')} />
        </Item>
      </Col>
    </Row>
  )
}
